import { CheckSharp } from '@mui/icons-material';

export type ICheckboxCellProps = {
  value: string;
};

export const StockArticleCell = (props: ICheckboxCellProps) => {
  const { value } = props;

  return (
    !value && (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CheckSharp />
      </div>
    )
  );
};
